/** Tekst geschikt maken voor `SpeechSynthesisUtterance` (geen markdown-ruis). */
export function stripMarkdownForSpeech(text: string): string {
  return text
    .replace(/```[\s\S]*?```/g, ' ')
    .replace(/`[^`]+`/g, ' ')
    .replace(/\[([^\]]+)\]\([^)]+\)/g, '$1')
    .replace(/[*_#>|]/g, ' ')
    .replace(/\s+/g, ' ')
    .trim();
}

export function speakText(
  text: string,
  lang = 'nl-NL',
  onEnd?: () => void,
): void {
  if (typeof window === 'undefined' || !window.speechSynthesis) return;
  stopSpeaking();
  const plain = stripMarkdownForSpeech(text);
  if (!plain) {
    onEnd?.();
    return;
  }
  const u = new SpeechSynthesisUtterance(plain);
  u.lang = lang;
  u.rate = 1;
  u.onend = () => onEnd?.();
  u.onerror = () => onEnd?.();
  window.speechSynthesis.speak(u);
}

export function stopSpeaking(): void {
  if (typeof window === 'undefined' || !window.speechSynthesis) return;
  window.speechSynthesis.cancel();
}

export function isSpeechSynthesisSupported(): boolean {
  return typeof window !== 'undefined' && !!window.speechSynthesis;
}
